import { Component } from 'react';
import PropTypes from 'prop-types';

export default function ShowComponent(MyComponent) {
  class HocComponent extends Component {
    constructor(props) {
      super(props);

      this.stopPropagation = this.stopPropagation.bind(this);
    }

    stopPropagation(e) {
      e.stopPropagation();
    }

    render() {
      const { show } = this.props;

      return (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div onClick={this.stopPropagation}>
          { show ?
            <div>
              <MyComponent {...this.props} />
            </div>
            : null }
        </div>
      );
    }
  }

  HocComponent.propTypes = {
    show: PropTypes.bool,
  };

  HocComponent.defaultProps = {
    show: false,
  };

  return HocComponent;
}

